module.exports = (eventName, properties, options, callback) ->
    analytics.track(eventName, _.extend({}, properties, { module: 'webapp' }), options, callback)
